import React, {Fragment, useState} from 'react';
import {Snackbar, Typography} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ErrorIcon from '@material-ui/icons/Error';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import axios from "axios";
import {makeStyles} from "@material-ui/core/styles";
import {useHistory} from "react-router-dom";
import SmallLoading from "../../../../utils/SmallLoading/SmallLoading";
import Alert from "@material-ui/lab/Alert";


const useStyles = makeStyles((theme) => ({
    divContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    subtitle: {
        fontFamily: "EncodeSansBold",
        fontSize: "18px",
        textAlign: "center",
    },
    numbers: {
        fontFamily: "EncodeSansRegular",
        fontSize: "16px",
        textAlign: "center"
    },
    congratsText: {
        fontFamily: "EncodeSansRegular",
        fontSize: "14px"
    },
    congratsTitle: {
        fontFamily: "EncodeSansBold",
        fontSize: "24px",
        color: "#bb0d66"
    },
    formControl: {
        width: '100%'
    },
    gridContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: theme.spacing(3)
    },
    centerText: {
        textAlign: 'center'
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center'
    },
    buttonContained: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#BB0D66",
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "20px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    alert: {
        backgroundColor: theme.palette.warning.dark
    },
}));

function EmisionSuccess(props) {
    const classes = useStyles();
    const history = useHistory()
    const {emisionResponse, setActiveStep, setEmisionResponse, finalValues, idCotizacion} = props;
    const [selectedDocument, setSelectedDocument] = useState(emisionResponse['status'] === "Pending"
        ? "ConstanciaCoberturaRC" : "Caratula");
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);

    const [loading, setLoading] = useState(false);

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null
    };

    const getOfficialNumberValue = (value) => {
        if (value == null || typeof value === 'object') {
            return null;
        }
        return value;
    };

    const getOfficialNumberDisplay = () => {
        const value = emisionResponse['officialNumber'];
        if (emisionResponse['status'] === "Pending") {
            return "Pendiente";
        }
        else if (value == null || typeof value === 'object') {
            return "-";
        }
        return String(value);
    };

    const handleOpenAlert = (message) => {
        setOpenAlert(true);
        setAlertMessage(message);
    };
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
        setAlertMessage(null);
    };

    async function getDocument() {

        setLoading(true)

        let url = process.env.REACT_APP_BACK_SERVER + '/documentacion/motovehiculo';

        let body = {
            "document": selectedDocument,
            "officialNumber": getOfficialNumberValue(emisionResponse['officialNumber']),
            "referenceNumber": emisionResponse['referenceNumber'],
            "operacionCliente": true,
            "origen": "affinity"
        };

        axios.post(url, body).then(res => {
            setLoading(false)
            openInNewTab(res.data)
        }).catch(err => {
            setLoading(false)
            handleOpenAlert("Ocurrió un error al descargar su documento, utilice sus códigos para consultarlos en la web de Sancor")
        });
    }

    return (
        <Fragment>
            {emisionResponse['status'] !== "Failed"
                ? (
                    <Fragment>
                        <div className={classes.divContainer}>
                            <Grid item xs={12} sm={8} className={classes.centerText} style={{marginBottom: "16px"}}>
                                <p className={classes.congratsTitle}>¡FELICITACIONES!</p>
                            </Grid>
                            <Grid item xs={12} sm={8} className={classes.centerText} style={{marginBottom: "32px"}}>
                                <p className={classes.subtitle}>La operación se ha completado con éxito</p>
                                <p className={classes.congratsText}>Descarga los documentos y anota los siguientes
                                    números para consultarlos en otra ocasión</p>
                            </Grid>
                        </div>
                        <Divider style={{margin: "8px"}}/>

                        <p className={classes.subtitle}>Número de Referencia:</p>
                        <p className={classes.numbers}>{emisionResponse['referenceNumber']}</p>

                        <p className={classes.subtitle}>Número Oficial de Póliza:</p>
                        <p className={classes.numbers}>{getOfficialNumberDisplay()}</p>

                        <p className={classes.subtitle}>Número de Trámite:</p>
                        <p className={classes.numbers}>{emisionResponse['managementNumber']}</p>

                        {/*<p className={classes.subtitle}>Número de Referencia:</p>*/}
                        {/*<p className={classes.numbers}>{emisionResponse['referenceNumber']}</p>*/}

                        <Divider style={{margin: "8px"}}/>
                        <Grid container spacing={2} className={classes.gridContainer}>
                            <Grid item xs={12} sm={4} className={classes.centerText}>
                                <p className={classes.subtitle}>Documentación</p>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel htmlFor="documentSelect">Documento</InputLabel>
                                    {emisionResponse['status'] === "Success"
                                        ? (
                                            <Select
                                                value={selectedDocument}
                                                onChange={(e) => setSelectedDocument(e.target.value)}
                                                name='documentSelect'
                                            >
                                                <MenuItem key={0} value={"Caratula"}>Póliza</MenuItem>
                                                <MenuItem key={1} value={"Factura"}>Factura</MenuItem>
                                                <MenuItem key={2} value={"ConstanciaDeCoberturaPE"}>
                                                    Certificado de Cobertura
                                                </MenuItem>
                                            </Select>
                                        )
                                        : (
                                            <Select
                                                value={selectedDocument}
                                                onChange={(e) => setSelectedDocument(e.target.value)}
                                                name='documentSelect'
                                            >
                                                <MenuItem key={0} value={"ConstanciaCoberturaRC"}>
                                                    Certificado de Cobertura Provisoria
                                                </MenuItem>
                                            </Select>
                                        )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4} className={classes.centerText}>

                                <Button
                                    onClick={() => {
                                        getDocument()
                                    }}
                                    variant='contained'
                                    color="primary"
                                    className={classes.buttonContained}
                                    style={{width: '110px', height: '40px'}}
                                >
                                    {!loading ? <p>Obtener </p> : <SmallLoading/>}

                                </Button>


                            </Grid>
                            {emisionResponse['status'] === "Pending" && (
                                <Fragment>
                                    <Divider/>
                                    <Grid item xs={12}>
                                        <p className={classes.congratsText}>
                                            El certificado de cobertura provisoria es un documento válido para circular
                                            hasta la emisión de la póliza.
                                            En el transcurso de 5 días hábiles estará disponible el resto de la
                                            documentación.
                                            En caso de que exista alguna irregularidad, un asesor se pondrá en
                                            contacto.
                                        </p>
                                    </Grid>
                                </Fragment>
                            )}
                        </Grid>
                    </Fragment>
                )
                : (
                    <Fragment>
                        <Typography gutterBottom
                                    style={{fontFamily: 'EncodeSansBold', fontSize: "18px", textAlign: "center"}}>
                            Ocurrió un error al procesar el pedido
                        </Typography>
                        <List>
                            {emisionResponse?.errors.map((row) => (
                                <ListItem>
                                    <ListItemIcon>
                                        <ErrorIcon/>
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={row['detail'] === 'Internal Error' ? 'Hay un problema con el servicio, vuelva a intentarlo más tarde.' : row['detail']}
                                    />
                                </ListItem>
                            ))}
                        </List>
                        <div className={classes.buttons}>
                            <Button
                                variant='contained'
                                color="primary"
                                className={classes.buttonContained}
                                onClick={() => {
                                    history.push({
                                        pathname: 'motovehiculo',
                                        state: {
                                            emisionValues: finalValues,
                                            idCotizacion: idCotizacion
                                        }
                                    })
                                    setEmisionResponse(null)
                                    setActiveStep(3)
                                }}
                            >
                                Volver al Formulario
                            </Button>
                        </div>
                    </Fragment>
                )}
            <Snackbar open={openAlert && alertMessage} autoHideDuration={5000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="warning" elevation={6} variant="filled"
                       classes={{filledWarning: classes.alert}}
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </Fragment>
    );
}

export default EmisionSuccess;
